import React, {Component} from 'react';
import v from 'voca';
import {inject, observer} from "mobx-react";
import { Request, VarHelper } from "common-import/helpers";
import Select from 'react-select';
import { sumBy } from 'lodash';
import { Link } from "react-router-dom";
import { IMAGE } from "common-import/constants";
import {UploadVideoModal, UploadDocumentModal} from "common-import/custom";
const defaultImage = 'http://jimenezylievanoabogados.com/en/wp-content/themes/jimenezylievanoabogados/images/no_image_profile.jpg';

const propertyContractor = [
  "name",
  "type",
  "address",
  "city",
  "country",
  "district",
  "phone",
  "mobile",
  "fax",
  "website",
  "email",
  "taxCode",
  "origination",
  "foundedYear",
  "description",
  "typeOfCompany",
  "qualityManagement",
  "language",
  "numberOfEmployees",
  "revenue",
  "unitRevenue",
  // "awards",
  // "verifyDocuments",
  "price",
  "pricing",
  // "listVideos",
  // "documents",
  // "finances",
  // "imageFinances",
  // "affiliations",
  // "services",
  "industries",
  "typeOfContractor",
  // "typeOfConstruction",
  "typeOfProject",
  // "typeOfBusiness",
  // "subBusiness",
  // "mainMarkets"
];

@inject("contractorStore", "masterStore", "routeStore") @observer
class ImportContractors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current: {},
      multiple: [],
      file: null,
      logo: null,
      cover: null,
      openVideoModal: false,
      openDocumentModal: false,
      isSaving: false,
      isModalSaving: false,
      isMultipleImport: false,
      isUploading: false,
    };
  }

  handleMultiSelectChange = (selectedOption, property) => {
    let values = [];
    let { current } = this.state;
    selectedOption.map((item) => {
      values.push(item.value);
    });
    current[property] = values;
    this.setState({
      current,
    });
  };

  onChangePhoto = (e, image) => {
    let { current } = this.state;
    const file = e.target.files[0];
    if (image === 'logo') {
      this.setState({
        logo: file,
        current: {...current, logo: URL.createObjectURL(file)}
      });
    } else if (image === 'cover') {
      this.setState({
        cover: file,
        current: {...current, wallImage: URL.createObjectURL(file)}
      })
    }
  };

  saveChangePhoto = async () => {
    const { current, logo, cover } = this.state;
    let logoURL = current.logo;
    let coverURL = current.wallImage;

    if (!!logo) {
      logoURL = await Request.upload(logo);
    }
    if (!!cover) {
      coverURL = await Request.upload(cover);
    }

    this.setState({
      logo: null,
      cover: null,
      current: {...current, logo: logoURL, wallImage: coverURL},
    });
  };

  renderForm = () => {
    const { current } = this.state;
    const {
      toValue,
      toSelectData,
      contractor_type,
      contractor_company_type,
      contractor_quality_management,
      contractor_sub_type,
      project_type,
      country, city, district, language
    } = this.props.masterStore;

    const propMaster = {
      type: contractor_type,
      typeOfCompany: contractor_company_type,
      qualityManagement: contractor_quality_management,
      typeOfContractor: contractor_sub_type,
      typeOfProject: project_type,
      industries: contractor_sub_type,
      language: language,
      country: country,
    };

    const renderOptions = (prop) => {
      const arr = [{id: 'null', label: '', value: 'null'}, ...toSelectData(propMaster[prop])];
      return arr.map((item, index) => {
        return (
          <option key={`${prop}${index}${item.id}`} value={item.id}>{item.label}</option>
        )
      })
    };

    // For multi select
    const getSelected = (property) => {
      if (current.hasOwnProperty(property) && current[property].length) {
        return current[property].map(item => {
          return { label: toValue(propMaster[property], item), value: item };
        });
      }
      return [];
    };
    // For multi select
    const getOptions = (property) => {
      let options = toSelectData(propMaster[property]);
      return options.map((item) => {
        item.value = item.id;
        return item;
      });
    };

    return (
      <form className="form">
        <div className="row">
          {
            propertyContractor.map((property, index) => {
              let element;
              if (property === 'description') {
                element = <div className="position-relative form-group">
                  <label htmlFor={"nf-" + property}>{v.capitalize(property)}:</label>
                  <textarea
                    className="form-control"
                    id={"nf-" + property}
                    name={"nf-" + property}
                    onChange={e => this.setState({
                      current: { ...current, [property]: e.target.value }
                    })}
                    placeholder={v.capitalize(property)}
                  />
                </div>
              } else if (["language", "type", "typeOfCompany", "country", "qualityManagement"].indexOf(property) !== -1) {
                element = <div className="position-relative form-group">
                  <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
                  <select
                    id={"nf-" + property}
                    name={"nf-" + property}
                    className="form-control"
                    value={current[property]}
                    onChange={e => this.setState({
                      current: { ...current, [property]: e.target.value }
                    })}
                    placeholder={v.capitalize(property)}
                  >
                    {renderOptions(property)}
                  </select>
                </div>
              } else if (["typeOfContractor", "typeOfProject", "industries"].indexOf(property) !== -1) {
                element = <div className="position-relative form-group">
                  <label htmlFor={"nf-" + property}>{v.capitalize(property)}:</label>
                  <Select isMulti
                          value={getSelected(property)}
                          onChange={(e) => this.handleMultiSelectChange(e, property)}
                          options={getOptions(property)}
                  />
                </div>
              } else if (["foundedYear", "revenue", "price"].indexOf(property) !== -1) {
                element = <div className="position-relative form-group">
                  <label htmlFor={"nf-" + property}>{v.capitalize(property)}:</label>
                  <input
                    type="number"
                    min={0}
                    id={"nf-" + property}
                    name={"nf-" + property}
                    className="form-control"
                    value={current[property] === null ? 0 : current[property]}
                    onChange={e => this.setState({
                      current: { ...current, [property]: e.target.value }
                    })}
                    placeholder={v.capitalize(property)}
                  />
                </div>
              } else {
                element = <div className="position-relative form-group">
                  <label htmlFor={"nf-" + property}>{v.capitalize(property)}:</label>
                  <input
                    type="text"
                    id={"nf-" + property}
                    name={"nf-" + property}
                    className="form-control"
                    value={current[property] === null ? '' : current[property]}
                    onChange={e => this.setState({
                      current: { ...current, [property]: e.target.value }
                    })}
                    placeholder={v.capitalize(property)}
                  />
                </div>
              }

              return (
                <div className="col-md-6" key={"property" + index}>
                  {element}
                </div>
              );
            })
          }
        </div>
      </form>
    )
  };

  renderSingleImport = () => {
    const { current } = this.state;
    return (
      <div className="row">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              {this.renderForm()}
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card">
            <div className="card-header">
              <span><i className="fa fa-picture-o"> </i> Logo</span>
            </div>
            <div className="text-center card-body">
              <div className="bg-image logo-preview" style={{backgroundImage: `url(${VarHelper.img(current.logo) || defaultImage})`}}> </div>
              <div className="form-group group-file-upload">
                <input onChange={e => this.onChangePhoto(e, 'logo')} type="file" id="upload-logo" name="upload-logo" style={{ display: 'none' }}/>
                <label className="btn btn-sm btn-danger" htmlFor="upload-logo"><i className="fa fa-camera"> </i> Upload logo</label>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header">
              <span><i className="fa fa-picture-o"> </i> Cover image</span>
            </div>
            <div className="text-center card-body">
              <div className="bg-image cover-preview" style={{backgroundImage: `url(${VarHelper.img(current.wallImage) || IMAGE})`}}> </div>
              <div className="form-group group-file-upload">
                <input onChange={e => this.onChangePhoto(e, 'cover')} type="file" id="upload-cover" name="upload-cover" style={{ display: 'none' }}/>
                <label className="btn btn-sm btn-danger" htmlFor="upload-cover"><i className="fa fa-camera"> </i> Upload cover image</label>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header">
              <span><i className="fa fa-video-camera"> </i> Videos</span>
            </div>
            <div className="card-body">
              <div className="input-group">
                <input type="text" disabled={true} className="form-control" placeholder="Video list"
                       value={!!current.listVideos ? current.listVideos.join(', ') : ''}
                />
                <div className="input-group-append">
                  <button type="button" className="btn btn-danger" onClick={() => this.handleOpenModal('video')}>Upload</button>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header">
              <span><i className="fa fa-envelope"> </i> Documents</span>
            </div>
            <div className="card-body">
              <div className="input-group">
                <input type="text" disabled={true} className="form-control"
                       value={!!current.documents ? current.documents.map(item => item.url).join(', ') : ''}
                />
                <div className="input-group-append">
                  <button type="button" className="btn btn-danger" onClick={() => this.handleOpenModal('document')}>Upload</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  };

  uploadXLSX = (e) => {
    e.preventDefault();
    this.setState({
      isUploading: true,
      file: e.target.files[0]
    });
    VarHelper.readXLSX(e, (data) => {
      console.log(data);
      const pricing = VarHelper.formatDataXLSX(data['pricing']);
      const houselinkRanking = VarHelper.formatDataXLSX(data['houselinkRanking']);
      const affiliations = VarHelper.formatDataXLSX(data['affiliations']);
      const finances = VarHelper.formatDataXLSX(data['finances']);
      let contractors = VarHelper.formatDataXLSX(data['Contractor']);
      contractors = this.syncData(contractors, 'houselinkRanking', houselinkRanking);
      contractors = this.syncData(contractors, 'pricing', pricing);
      contractors = this.syncData(contractors, 'affiliations', affiliations);
      contractors = this.syncData(contractors, 'finances', finances);
      this.setState({
        isUploading: false,
        multiple: contractors
      });
    }, ['Contractor', 'pricing', 'houselinkRanking', 'affiliations', 'finances']);
  };

  /*
  * @param original
  * @param field // field name: works, materials...
  * @param data
* */
  syncData = (original = [], field, data = []) => {
    return original.map((item) => {
      const filterData = data.filter(itm => item.STT === itm.STTC);
      return {...item, [field]: filterData};
    });
  };

  formatSomeValues = (obj) => {
    const {
      findID,
      contractor_type,
      contractor_company_type,
      contractor_quality_management,
      contractor_affiliations,
      country, city, district,
    } = this.props.masterStore;

    const propMaster = {
      type: contractor_type,
      typeOfCompany: contractor_company_type,
      qualityManagement: contractor_quality_management,
      country: country,
      city: city,
      district: district
    };

    const formatHouseLinkRanking = (arr) => {
      const newArr = arr.map((item) => {
        item.score = VarHelper.getScoreByPerform(item.perform.toString().split("-")[0]);
        return item;
      });
      return {
        result: sumBy(newArr, 'score') + VarHelper.getRanking(sumBy(newArr, 'score')),
        mainCriterias: newArr,
      }
    };

    const needToConvert = ["type", "typeOfCompany", "qualityManagement", "language", "country"];
    let newObj = {};
    for (let key in obj) {
      if (needToConvert.indexOf(key) !== -1) {
        newObj[key] = findID(propMaster[key], obj[key]);
      } else if (["listImages", "listVideos", "awards", "imageFinances"].indexOf(key) !== -1) {
        newObj[key] = obj[key].split(",");
      } else if (key === "documents") {
        const arr = obj[key].split(",");
        newObj[key] = arr.map((item, index) => {
          return { id: index, url: item };
        });
      } else if (key === "houselinkRanking") {
        newObj[key] = formatHouseLinkRanking(obj[key]);
      } else if (key === "finances") {
        newObj[key] = obj[key];
        if (!!obj[key] && !!obj[key][0] && !!obj[key][0]["revenue"]) {
          newObj["revenue"] = obj[key][0]["revenue"];
          newObj["unitRevenue"] = newObj["unitPrice"] = obj[key][0]["currencyUnit"];
        }
      } else if (key === "affiliations") {
        newObj[key] = obj[key].map((item) => {
          return {
            id: item.id,
            en: contractor_affiliations['en'][Number(item.id)],
            vi: contractor_affiliations['vi'][Number(item.id)],
            img: contractor_affiliations['img'][Number(item.id)]
          };
        });
      } else {
        newObj[key] = obj[key];
      }
    }
    return newObj;
  };

  updateHouseLink = async (obj, id) => {
    const { contractorStore } = this.props;
    let { isVerifiedFinances, isVerifiedLicense, isHouseLinkMember, houselinkRanking } = obj;
    const params = {
      id,
      isVerifiedFinances: isVerifiedFinances.toLowerCase() === 'yes' ? 1 : 0,
      isVerifiedLicense: isVerifiedLicense.toLowerCase() === 'yes' ? 1 : 0,
      isHouseLinkMember: isHouseLinkMember.toLowerCase() === 'yes',
      houselinkRanking: !!houselinkRanking ? houselinkRanking : {},
    };
    return await contractorStore.updateHouseLink(params);
  };

  makeDelay = (time) => {
    return new Promise((resolve) => {
      setTimeout(() => resolve(console.log('Delay ' + time + 'ms')), time);
    })
  };

  addMultiple = async () => {
    const { contractorStore } = this.props;
    const { multiple } = this.state;
    if (!multiple.length) return null;
    this.setState({ isSaving: true });
    for (let i = 0; i < multiple.length; i++) {
      // uploadStatus: 0 - uploading, 1 - uploaded success, 2 - uploaded failure
      multiple[i]['uploadStatus'] = 0;
      this.setState({ multiple });
      const data = this.formatSomeValues(multiple[i]);
      console.log(data);
      const payload = this.formatPayload(data);
      const res = await contractorStore.create(payload);
      if (!!res.error) {
        multiple[i]['uploadStatus'] = 2;
        multiple[i]['uploadErrorMessage'] = res.error;
      } else {
        if (!!data.approved && data.approved.toLowerCase() === "yes") {
          const resApprove = await contractorStore.approve({id: res.data.id, approved: true});
          const resUpdateHouseLink = await this.updateHouseLink(data, res.data.id);

          if (!!resApprove.error || !!resUpdateHouseLink.error) {
            multiple[i]['uploadStatus'] = 2;
            if (!!resApprove.error) multiple[i]['uploadErrorMessage'] = 'APPROVED ERROR: ' + resApprove.error;
            if (!!resUpdateHouseLink.error) multiple[i]['uploadErrorMessage'] = 'UPDATE HOUSELINK ERROR: ' + resUpdateHouseLink.error;
          } else {
            multiple[i]['uploadStatus'] = 1;
          }
        }
      }
      // await this.makeDelay(1000);
      this.setState({ multiple });
    }
    window.toast.info('Finish!');
    this.setState({ isSaving: false, file: null });
  };

  renderMultipleImport = () => {
    const { file, isSaving, isUploading, multiple } = this.state;

    const showUploadStatus = () => {
      if (!isSaving && !multiple.length) return (<h6>{isUploading ? 'Uploading...' : ''}</h6>);
      const errorList = multiple.filter(item => item.hasOwnProperty('uploadStatus') && item.uploadStatus === 2);
      const successList = multiple.filter(item => item.hasOwnProperty('uploadStatus') && item.uploadStatus === 1);

      const renderStatus = (list) => {
        return list.map((item, index) => {
          return <p key={'status-'+index}>
            {item.name} (STT: {item.STT}) {!!item.uploadErrorMessage ? item.uploadErrorMessage : ''}
          </p>
        });
      };
      const blockStyle = {
        maxHeight: '256px',
        overflowY: 'auto',
        marginTop: '24px',
      };
      return (
        <div className="row">
          <div className="col-md-12">
            <h6 style={{marginBottom: '16px', display: !!file ? 'block': 'none'}}>
              {multiple.length} contractors will be added.
            </h6>
          </div>
          <div style={{display: successList.length ? 'block' : 'none'}} className="col-md-6">
            <h5 className="text-success">Success: {successList.length} items</h5>
            <div style={blockStyle}>
              {renderStatus(successList)}
            </div>
          </div>
          <div style={{display: errorList.length ? 'block' : 'none'}} className="col-md-6">
            <h5 className="text-danger">Failure: {errorList.length} items</h5>
            <div style={blockStyle}>
              {renderStatus(errorList)}
            </div>
          </div>
        </div>
      )
    };

    return (
      <div className="multiple-import">
        <div className="row">
          <div className="col-md-6">
            <div style={{marginBottom: '16px'}}>
              <a target="_blank" href="https://drive.google.com/drive/folders/1YjwJTADWCYt3C5RoS-G0JOmFeDHT28AG?usp=drive_open">
                Sample data here
              </a>
            </div>
            <div className="input-group">
              <input value={!!file ? file.name : ''} type="text" disabled={true} className="form-control" placeholder="*.xls / *.xlsx"/>
              <div className="input-group-append">
                <div style={{marginBottom: 0}} className="form-group group-file-upload">
                  <input onChange={e => this.uploadXLSX(e)} type="file" id="upload-files" name="upload-files" multiple={true} style={{display: "none"}}/>
                  <label className="btn btn-danger" htmlFor="upload-files"><i className="fa fa-envelope"> </i> Upload file</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{marginTop: '24px'}}>
          {/*{showUploadStatus()}*/}
        </div>
      </div>
    )
  };

  formatPayload = (data) => {
    let copy;

    const typeFormat = {
      typeObject: ["verifyDocuments"],
      typeNumber: ["foundedYear", "revenue", "price"],
      typeArray: ["awards", "pricing", "listVideos", "documents", "finances", "imageFinances", "affiliations", "services", "industries", "typeOfContractor", "typeOfConstruction", "typeOfProject","typeOfBusiness", "subBusiness", "mainMarkets"],
      typeString: ["name", "type", "wallImage", "logo", "address", "city", "country", "district", "phone", "mobile", "fax", "website", "email", "taxCode", "origination", "description", "typeOfCompany", "qualityManagement", "language", "unitRevenue", "unitPrice"],
    };

    let keyList = [];
    for (let key in typeFormat) {
      keyList = [...keyList, ...typeFormat[key]];
    }

    copy = VarHelper.copyObjectWithKey(keyList, data);
    return VarHelper.formatValueByType(copy, typeFormat);
  };

  addSingle = async () => {
    const { contractorStore } = this.props;
    const { current } = this.state;

    this.setState({ isSaving: true });
    const payload = this.formatPayload(current);
    await this.saveChangePhoto();
    const res = await contractorStore.create(payload);
    this.setState({ isSaving: false });

    if (!!res.error) {
      return window.toast.error('Created failure: ' + JSON.stringify(res.error));
    }

    this.setState({
      current: {},
    });

    return window.toast.info('Created successfully.');
  };

  handleAdd = async (e) => {
    !!e && e.preventDefault();
    const { isMultipleImport } = this.state;
    if (!isMultipleImport) {
      await this.addSingle();
    } else {
      await this.addMultiple();
    }
  };

  clearData = (e) => {
    e.preventDefault();
    const { isMultipleImport } = this.state;
    if (window.confirm('Are you sure want to clear all inputs?')) {
      if (!isMultipleImport) {
        this.setState({ current: {} });
      } else {
        this.setState({ multiple: [], file: null });
      }
      this.setState({ isUploading: false, isSaving: false });
    }
  };

  handleCloseModal = () => {
    this.setState({
      openVideoModal: false,
      openDocumentModal: false,
    });
  };

  handleOpenModal = (type) => {
    this.setState({
      openVideoModal: type === 'video',
      openDocumentModal: type === 'document',
    });
  };

  handleSubmitModal = async (list) => {
    const { current, openDocumentModal, openVideoModal } = this.state;

    if (openVideoModal) {
      current.listVideos = [...list];
      this.setState({ current });
    } else if (openDocumentModal) {
      current.documents = [...list];
      this.setState({ current });
    }

    this.setState({ isModalSaving: true });
    setTimeout(() => {
      this.setState({
        isModalSaving: false,
        openDocumentModal: false,
        openVideoModal: false,
      });
    }, 500);
  };

  importSingle = async () => {
    if (this.state.isImportingSingle) return;
    this.setState({ isImportingSingle: true, singleImportMessage: '', singleImportLink: '' });
    const { HLOldId } = this.state;
    const { contractorStore, routeStore } = this.props;
    const res = await contractorStore.importOldSystem(HLOldId);
    this.setState({ isImportingSingle: false });
    if (!!res.error) return window.toast.error('Có lỗi xảy ra, vui lòng thử lại');
    const { isAlreadyExisted, contractorData } = res.data;
    this.setState({
      singleImportMessage: isAlreadyExisted ? 'Contractor này đã được thêm từ trước vào rồi' : 'Import thành công',
      singleImportLink: routeStore.admin.contractorDetail(contractorData.id, contractorData.name)
    })
  }

  render() {
    const { current, isSaving, isMultipleImport, isModalSaving, openVideoModal, openDocumentModal, HLOldId, isImportingSingle, singleImportMessage, singleImportLink } = this.state;

    return (
      <div id="import-project-page" className="animated fadeIn">
        <div className="card">
          <div className="card-header">
            <div className="card-header-left">
              <i className="fa fa-envelope-open"> </i> Import from old system
            </div>
          </div>
          <div className="card-body">
            <p>Note: Xem hướng dẫn lấy id ở mục <a href='/#/tutorials' target="_blank">Tutorials</a></p>
            <input placeholder="Điền ID cũ" type="text" className="form-control" value={HLOldId} onChange={(e) => this.setState({ HLOldId: e.target.value })} />
            {!!singleImportMessage && <p>{singleImportMessage}</p>}
            {!!singleImportLink && <p><Link to={singleImportLink} target="_blank">Vào xem: {singleImportLink}</Link></p>}
          </div>
          <div className="card-footer">
            <button className="btn btn-sm btn-primary" onClick={(e) => this.importSingle(e)}>
              <i className="fa fa-dot-circle-o"> </i> { isImportingSingle ? 'Importing...' : 'Import' }
            </button>
          </div>
        </div>
        <div className="card">
          <div className="card-header">
            <div className="card-header-left">
              <i className="fa fa-envelope-open"> </i> Import new contractor
            </div>
            <div className="card-header-right">
              <button className="btn btn-sm btn-primary"
                      onClick={() => this.setState({ isMultipleImport: !isMultipleImport })}>
                Switch to {isMultipleImport ? 'Single Import' : 'Multiple Import'}
              </button>
            </div>
          </div>
          <div className="card-body">
            {isMultipleImport ? this.renderMultipleImport() : this.renderSingleImport()}
          </div>
          <div className="card-footer">
            <button className="btn btn-sm btn-primary" disabled={isSaving} onClick={(e) => this.handleAdd(e)}>
              <i className="fa fa-dot-circle-o"> </i> { isSaving ? 'Saving...' : 'Save' }
            </button>
            <button className="btn btn-sm btn-danger" onClick={e => this.clearData(e)}>
              <i className="fa fa-ban"> </i> Clear
            </button>
          </div>
        </div>
        <UploadVideoModal
          open={openVideoModal}
          saving={isModalSaving}
          list={current.listVideos || []}
          onClose={this.handleCloseModal}
          onSubmit={this.handleSubmitModal}
        > </UploadVideoModal>
        <UploadDocumentModal
          open={openDocumentModal}
          saving={isModalSaving}
          list={current.documents || []}
          onClose={this.handleCloseModal}
          onSubmit={this.handleSubmitModal}
        > </UploadDocumentModal>
      </div>
    );
  }
}

export default ImportContractors;



// WEBPACK FOOTER //
// ./src/views/Contractors/Import.js